import JSZip from "jszip";
import FileSaver from 'file-saver';
export var exportZipFile = function (files, name, type, cbSuccessDownload) {
    var zip = new JSZip();
    files.forEach(function (file) {
        var name = file.name, fileData = file.fileData;
        // FileSaver.saveAs(fileData, name);  
        zip.file(name, fileData, { base64: type == "IMAGE" ? true : false });
    });
    zip.generateAsync({ type: 'blob' }).then(function (content) {
        if (content) {
            FileSaver.saveAs(content, name);
            cbSuccessDownload();
        }
    });
};
export var exportEachCSV = function (files) {
    if (files && files.length) {
        var download = function (urls) {
            var url = urls.pop();
            var a = document.createElement("a");
            a.setAttribute('href', url.fileData);
            a.style.visibility = 'hidden';
            a.click();
            if (urls.length == 0) {
                clearInterval(interval);
            }
        };
        var interval = setInterval(download, 800, files);
    }
};
export var exportCSVFromContents = function (fileName, contents, typeExport) {
    if (typeExport == "URL") {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var urlClick = contents;
            link.setAttribute("href", urlClick);
            link.setAttribute("download", fileName + ".csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
        }
    }
    else {
        var blob = new Blob(['\uFEFF' + contents], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, fileName);
        }
        else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", fileName + ".csv");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
            }
        }
    }
};
